import { render, staticRenderFns } from "./recoveryList.vue?vue&type=template&id=03733578"
import script from "./recoveryList.vue?vue&type=script&lang=js"
export * from "./recoveryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports